module.exports = __webpack_public_path__ + "static/media/icon_samsung_store.f0954fbf.svg";